module.exports = __webpack_public_path__ + "img/section3-bg1.b7157832.png";